import { render, staticRenderFns } from "./CustomerImportFailure.vue?vue&type=template&id=000aa584&scoped=true&"
import script from "./CustomerImportFailure.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportFailure.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportFailure.vue?vue&type=style&index=0&id=000aa584&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000aa584",
  null
  
)

export default component.exports